/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const BaseSwapThis = ({ change = "Change this" }) => {
  return (
    <div className="base-swap-this">
      <div className="change-this">{change}</div>
    </div>
  );
};

BaseSwapThis.propTypes = {
  change: PropTypes.string,
};
